import type { TicketBoardViewColumn } from './types';

export const createViewColumn = (
  props: TicketBoardViewColumn
): TicketBoardViewColumn => ({
  columnWidth: 200,
  ...props,
});
